module.exports = __webpack_public_path__ + "img/setup-cook-off-min.569d4ead.jpg";